import React, { Component } from "react";
import "./style.scss";
import {
  NormalDateTime,
  NormalTable,
  Search,
  NormalButton,
  TableWrapper,
} from "component/common";
import { dateFormat } from "service/helperFunctions";
import { withTranslation } from "react-i18next";
import { getCommonApi } from "redux/actions/common";
import _ from "lodash";
import SearchIcon from "assets/images/ipad-icons/SearchIcon.svg";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { history } from "helpers";

// import { HistoryPopup } from "../Historypoup/HistoryPopup";
import { format } from "date-fns";

export class SalesDashboardClass extends Component {
  state = {
    meta: {},
    headerDetails: [
      { label: "Customer Code" },
      { label: "Name" },
      { label: "NRIC" },
      { label: "Join Date" },
      { label: " " },
      { label: " " },
    ],
    customerOption: [],
    historyData: [],
    formField: {
      fromDate: new Date(),
      toDate: new Date(),
      search: "",
    },
    isHistoryPopup: false,
    active: false,
    currentIndex: -1,
    page: 1,
    limit: 12,
    isOpenvoidCheckout: false,
    pageMeta: {},
    arAnalysisData: [
      {
        title: "SVC (疗程)",
        value: 0.0,
      },
      {
        title: "PRD (产品)",
        value: 0.0,
      },
      {
        title: "PP (预付配套)",
        value: 0.0,
      },
      {
        title: "PKG (配套)",
        value: 0.0,
      },
    ],
    businessData: [
      {
        title: "08/12/2023",
        value: 0,
        color: "#77f7f7",
      },
      {
        title: "MTD (本月至今)",
        value: 0.0,
        color: "#92f792",
      },
      {
        title: "YTD (本年至今)",
        value: 0.0,
        color: "#92f792",
      },
      {
        title: "Last Year (上年)",
        value: 0.0,
        color: "#ffffff",
      },
      {
        title: "Outlook (客户数量的前景)",
        value: 0.0,
        color: "#fae987",
      },
    ],
    apptStatusData: [
      {
        title: "Booking",
        chineseTitle: "预订",
        value: 0,
        color: "#fae987",
      },
      {
        title: "Waiting List",
        chineseTitle: "等候",
        value: 0,
        color: "#db87fa",
      },
      {
        title: "Confirmed",
        chineseTitle: "确认",
        value: 0,
        color: "#fac487",
      },
      {
        title: "No Show",
        chineseTitle: "没出现",
        value: 0,
        color: "#c5c7c7",
      },
      {
        title: "Arrived",
        chineseTitle: "抵达",
        value: 0,
        color: "#77f7f7",
      },
      {
        title: "Done",
        chineseTitle: "完成",
        value: 0,
        color: "#92f792",
      },
      {
        title: "Cancel",
        chineseTitle: "取消",
        value: 0,
        color: "#fc9181",
      },
      {
        title: "Last Min Cancel",
        chineseTitle: "最后一分钟取消",
        value: 0,
        color: "#5ae0cc",
      },
    ],
    headerDetails: [
      { label: "Name" },
      { label: "Work In" },
      { label: "Work Out" },
    ],
    ar_analysis_value: {},
    resources: [],
  };
  componentDidMount() {
    let { formField } = this.state;
    const currentDate = formField.toDate;
    const day = String(currentDate.getDate()).padStart(2, "0");
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const year = currentDate.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    console.log(formattedDate, "formatDates");
    const updatedData = [
      {
        title: formattedDate,
        value: 0,
        color: "#77f7f7",
      },
      {
        title: "MTD (本月至今)",
        value: 0.0,
        color: "#92f792",
      },
      {
        title: "YTD (本年至今)",
        value: 0.0,
        color: "#92f792",
      },
      {
        title: "Last Year (上年)",
        value: 0.0,
        color: "#ffffff",
      },
      {
        title: "Outlook (客户数量的前景)",
        value: 0.0,
        color: "#fae987",
      },
    ];

    this.setState({
      businessData: updatedData,
    });
  }

  /* Input handleChange */
  handleChange = async (event) => {
    let { formField } = this.state;
    formField.search = event.target.value;
    this.setState({ formField });
  };

  /* Date Handler */
  handleDatePick = async (name, value) => {
    let { formField, businessData } = this.state;

    formField[name] = value;
    const currentDate = formField.toDate;
    const day = String(currentDate.getDate()).padStart(2, "0");
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const year = currentDate.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    console.log(formattedDate, "formatDates");
    const updatedData = [
      {
        title: formattedDate,
        value: 0,
        color: "#77f7f7",
      },
      {
        title: "MTD (本月至今)",
        value: 0.0,
        color: "#92f792",
      },
      {
        title: "YTD (本年至今)",
        value: 0.0,
        color: "#92f792",
      },
      {
        title: "Last Year (上年)",
        value: 0.0,
        color: "#ffffff",
      },
      {
        title: "Outlook (客户数量的前景)",
        value: 0.0,
        color: "#fae987",
      },
    ];

    this.setState({
      businessData: updatedData,
    });

    this.setState({
      formField,
    });
  };

  /* Search Api */
  getTransactions = (data) => {
    let { customerOption, formField, apptStatusData, resources, businessData } =
      this.state;
    let { fromDate, toDate, search } = formField;
    let { page = 1, limit = 12 } = data;
    this.setState({ customerOption });
    let From = new Date();
    if (fromDate && fromDate !== "") {
      From = fromDate;
    } else {
      this.setState({ fromDate: From });
    }
    let To = new Date();
    if (toDate && toDate !== "") {
      To = toDate;
    } else {
      this.setState({ toDate: To });
    }
    this.props
      .getCommonApi(
        `spadashboard/?from_date=${dateFormat(
          From,
          "yyyy-mm-dd"
        )}&to_date=${dateFormat(To, "yyyy-mm-dd")}`
      )
      .then((key) => {
        let { status, data } = key;
        console.log(key, "dashboardRes");
        let apptStatusValue = key.appt_status;
        console.log(apptStatusValue, "apptStatusValue");
        for (let list of key.att_lst) {
          resources.push(list);
        }
        const updatedStatusData = apptStatusData.map((list) => {
          console.log(list.title, "listTitle");
          return {
            ...list,
            value:
              list.title === "Booking"
                ? apptStatusValue.booking
                : list.title === "Waiting List"
                ? apptStatusValue.waiting_lst
                : list.title === "Confirmed"
                ? apptStatusValue.confirmed
                : list.title === "No Show"
                ? apptStatusValue.no_show
                : list.title === "Arrived"
                ? apptStatusValue.arrived
                : list.title === "Done"
                ? apptStatusValue.done
                : list.title === "Cancel"
                ? apptStatusValue.cancel
                : list.title === "Last Min Cancel"
                ? apptStatusValue.lastmincancel
                : "",
          };
        });
        const updatedBusinessData = businessData.map((item) => {
          return {
            ...item,
            value:
              item.title === "08/12/2023"
                ? key.current_date_TD
                : item.title === "MTD (本月至今)"
                ? key.MTD
                : item.title === "YTD (本年至今)"
                ? key.YTD
                : item.title === "Last Year (上年)"
                ? key.LYTD
                : "",
          };
        });
        console.log(updatedBusinessData, "updatedBusiness");
        console.log(resources, "apptStatus");
        this.setState({
          ar_analysis_value: key.ar_analysis,
          apptStatusData: updatedStatusData,
          resources,
          businessData: updatedBusinessData,
        });
      });
  };

  /* Add Customer Details Popup*/
  handleHistoryNewPopup = async (id, event) => {
    event.preventDefault();
    let { formField, isHistoryPopup } = this.state;
    this.setState({
      isHistoryPopup: !isHistoryPopup,
    });
    if (!isHistoryPopup) {
      let fromDateHistory = format(new Date(formField.fromDate), "yyyy-MM-dd");
      let toDateHistory = format(new Date(formField.toDate), "yyyy-MM-dd");

      this.props
        .getCommonApi(
          `transactioncustomer/listtncdetail/?from_date=${fromDateHistory}&to_date=${toDateHistory}&cust_id=${id}`
        )
        .then((key) => {
          let { data, meta } = key;
          let { historyData } = this.state;
          this.setState({
            historyData: data.dataList,
            pageMeta: meta,
          });
        });
    }
  };

  handlePopUp = () => {
    this.setState({
      isHistoryPopup: false,
    });
  };
  /* Get Api Package Details */
  handleClick = (item) => {
    history.push({
      pathname: "/admin/termsandconditionsignpage",
      state: {
        id: item.id,
        data: this.state.formField,
        cust: item.cust_code,
        name: item.cust_name,
      },
    });
  };

  /* Clear Input Box */
  Clear = () => {
    this.setState({
      formField: {
        fromDate: new Date(),
        toDate: new Date(),
        search: "",
      },
    });
  };

  /* Clear List Function */
  handleresetlist = () => {
    this.setState({
      customerOption: "",
      handlePagination: "",
    });
  };

  /* pagination */
  handlePagination = (page) => {
    this.getTransactions(page);
  };

  render() {
    let {
      headerDetails,
      customerOption,
      formField,
      meta,
      isHistoryPopup,
      ar_analysis_value,
    } = this.state;

    const currentDate = formField.toDate;
    const fromCurrentDate = formField.fromDate;
    const fromDay = String(fromCurrentDate.getDate()).padStart(2, "0");
    const fromMonth = String(fromCurrentDate.getMonth() + 1).padStart(2, "0");
    const fromYear = fromCurrentDate.getFullYear();
    const fromFormattedDate = `${fromDay}/${fromMonth}/${fromYear}`;
    const day = String(currentDate.getDate()).padStart(2, "0");
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const year = currentDate.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    console.log(formattedDate, "formatDate");

    let { fromDate, toDate, search } = formField;
    let { t } = this.props;
    return (
      <>
        <div className="col-12 mt-3 dashboard-main-container bg-grey">
          <p className="ipad-heading dashboard-header mt-3 px-3 pt-4 pb-4 ">
            Sales Dashboard
          </p>
          <div className="row mx-2  webConsultationSearch">
            <div className="col-12 bg-white rounded mx-auto">
              <div className="col-12 ">
                <div className="row">
                  {/* <div className="col-md-8 col-12 px-0 my-3">
                    <Search
                      rightIcon={SearchIcon}
                      value={search}
                      name="search"
                      onChange={this.handleChange}
                      placeholder="Search by customer name, NRIC, Code, Contact no."
                      onClick={this.getTransactions}
                    />
                  </div> */}
                </div>
              </div>
              <div className="col-12 px-1 mb-4">
                <div className="row">
                  <div className="mt-4 col-md-4 col-12 ">
                    <label className="mb-2">{t("From Date")}</label>
                    <div className="input-group">
                      <NormalDateTime
                        onChange={this.handleDatePick}
                        inputcol="p-0 inTime"
                        value={fromDate ? new Date(fromDate) : new Date()}
                        name="fromDate"
                        showYearDropdown={true}
                        showMonthDropdown={true}
                        dateFormat="dd/MM/yyyy"
                        maxDate={new Date(toDate)}
                        showDisabledMonthNavigation
                      />
                    </div>
                  </div>
                  <div className="mt-4 col-md-4 col-12 ">
                    <label className="mb-2">{t("To Date")}</label>
                    <div className="input-group">
                      <NormalDateTime
                        onChange={this.handleDatePick}
                        inputcol="p-0 inTime"
                        value={toDate ? new Date(toDate) : new Date()}
                        name="toDate"
                        showYearDropdown={true}
                        dateFormat="dd/MM/yyyy"
                        minDate={new Date(fromDate)}
                        showDisabledMonthNavigation
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row py-4">
                <div className="col-md-3 col-6 py-md-0 py-2">
                  <NormalButton
                    mainbg={false}
                    className="col-12 submit-btn"
                    label="Go"
                    onClick={this.getTransactions}
                  />
                </div>
              </div>
              <div className="col-md-12 col-lg-12 mt-5 d-flex flex-wrap">
                <div className="col-md-5 ar-main-container p-3 mr-md-4 mt-4">
                  <p className="text-center dashboard-font">
                    AR Analysis 收入分析
                  </p>
                  <p className="mt-3  dashboard-font">
                    {fromFormattedDate} - {formattedDate}
                  </p>
                  <div className="ar-data-container  ">
                    <div className="ar-data">
                      <p className=" dashboard-font">SVC (疗程):</p>
                      <p>{ar_analysis_value.SVC ? ar_analysis_value.SVC : 0}</p>
                    </div>
                    <div className="ar-data">
                      <p className=" dashboard-font">PRD (产品):</p>
                      <p>{ar_analysis_value.PRD ? ar_analysis_value.PRD : 0}</p>
                    </div>
                    <div className="ar-data">
                      <p className=" dashboard-font">PP (预付配套):</p>
                      <p>{ar_analysis_value.PP ? ar_analysis_value.PP : 0}</p>
                    </div>
                    <div className="ar-data">
                      <p className=" dashboard-font">PKG (配套):</p>
                      <p>{ar_analysis_value.PKG ? ar_analysis_value.PKG : 0}</p>
                    </div>
                    {/* {this.state.arAnalysisData.map((list) => (
                      <div className="ar-data">
                        <p>{list.title} :</p>
                        <p>{list.value}</p>
                      </div>
                    ))} */}
                  </div>
                  <div className="d-flex col-md-12 mt-3 p-0">
                    <div className="ar-bottom-container">
                      <div className="total-ar-container ">
                        <div className="">
                          <p className=" dashboard-font">Total AR</p>
                          <p className=" dashboard-font">(总余额): </p>
                        </div>
                        <p>
                          {ar_analysis_value.total_ar
                            ? ar_analysis_value.total_ar
                            : 0}
                        </p>
                      </div>
                      <div className="total-ar-container ">
                        <div className="">
                          <p className=" dashboard-font">Total SA</p>
                          <p>(总销售额): </p>
                        </div>
                        <p>
                          {ar_analysis_value.total_sa
                            ? ar_analysis_value.total_sa
                            : 0}
                        </p>
                      </div>
                    </div>

                    <div className="ar-rate-container">
                      <div className="total-ar-rate-container">
                        <p className=" dashboard-font">AR Rate</p>
                        <p className=" dashboard-font">总余额率 </p>
                      </div>
                      <div className="total-ar-container ">
                        {ar_analysis_value.ar_rate
                          ? ar_analysis_value.ar_rate
                          : 0}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-5 appt-status-container p-3 mt-4">
                  <p className="text-center dashboard-font">
                    Appt status 预约分析
                  </p>
                  <p className="mt-3 dashboard-font">{formattedDate} </p>
                  <div className="appt-card-main-container">
                    {this.state.apptStatusData.map((list) => {
                      return (
                        <div
                          className="text-center appt-card-container"
                          style={{ backgroundColor: list.color }}
                        >
                          <p className=" dashboard-font">{list.title}</p>
                          <p className=" dashboard-font">{list.chineseTitle}</p>
                          <p className="appt-card-value">{list.value}</p>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="col-md-5 appt-resource-container p-3 mt-4">
                  <p className="text-center dashboard-font">Resources 团队</p>
                  <p className="mt-3 dashboard-font">{formattedDate} </p>
                  <div className="mt-4">
                    <TableWrapper headerDetails={headerDetails} bgWhite={true}>
                      {this.state.resources.length > 0 ? (
                        this.state.resources.map((item) => (
                          <tr>
                            <td className=" dashboard-font">{item.name}</td>
                            <td className=" dashboard-font">
                              {JSON.stringify(item.work_in)}
                            </td>
                            <td className=" dashboard-font">
                              {JSON.stringify(item.work_out)}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td>
                            <div className="p-5 ">No Data</div>
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}
                    </TableWrapper>
                  </div>
                </div>
                <div className="col-md-5 business-main-container p-3 ml-md-4 mt-4">
                  <p className="text-center dashboard-font">
                    Business Outlook 公司趋势
                  </p>

                  <div className="mb-5">
                    {this.state.businessData.map((list) => (
                      <div
                        className="business-data"
                        style={{ backgroundColor: list.color }}
                      >
                        <p className=" dashboard-font">{list.title} : </p>
                        <p>{list.value !== "" ? list.value : 0}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
    },
    dispatch
  );
};
export const SalesDashboard = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(SalesDashboardClass)
);
